import { Title } from 'theme/theme';
import styled from "styled-components";
import { Type } from 'theme/types';

export const TitleSurvey = styled(Title)`
  ${({theme}: Type) => theme?.surveys?.text?.title}
`